// 网黑料 单页首页静态展示数据（虚构示例，仅为演示排版与观感）

export const heroVisualImage =
  "https://readdy.ai/api/search-image?query=Stylized%20editorial%20poster%20illustration%20of%20a%20single%20mysterious%20silhouette%20figure%20seen%20from%20behind%20inside%20a%20dark%20interrogation%20room%2C%20warm%20vermilion%20red%20rim%20light%20from%20the%20left%20side%20and%20deep%20charcoal%20shadows%20filling%20the%20scene%2C%20thin%20gold%20archival%20frame%20lines%20and%20sparse%20document%20dots%20floating%2C%20cinematic%20dramatic%20mood%2C%20flat%20modern%20graphic%20vector%20art%2C%20restrained%20clean%20composition%2C%20dark%20warm%20background%20with%20high%20contrast%20lighting&width=600&height=720&seq=hero-visual-2026&orientation=portrait";

export const heroHotWords = [
  { word: "人设考古", url: "#topic" },
  { word: "带货翻车", url: "#rank" },
  { word: "学历注水", url: "#archive" },
  { word: "言论回溯", url: "#timeline" },
  { word: "频道改名", url: "#collection" },
];

export const channels = [
  {
    id: "dig",
    no: "01",
    name: "深扒",
    en: "DEEP DIVE",
    desc: "把一条线索顺藤摸瓜拆到底，逐层比对人设、数据与旧物料，看水分究竟出在哪一环。",
    meta: "收录专题 128 期",
    icon: "ri-focus-3-line",
  },
  {
    id: "person",
    no: "02",
    name: "人物起底",
    en: "PERSON FILE",
    desc: "以人物为单位建立档案，还原其早期轨迹、阶段转折与公开表态，拼出一份可核验的背景。",
    meta: "档案词条 3,4k",
    icon: "ri-user-search-line",
  },
  {
    id: "bg",
    no: "03",
    name: "背景揭秘",
    en: "BACKGROUND",
    desc: "翻查登记、团队、履历与背后的运作，把台前形象对应的真实背景一层层摊开给你看。",
    meta: "揭秘条目 216 条",
    icon: "ri-eye-line",
  },
  {
    id: "insider",
    no: "04",
    name: "内幕",
    en: "INSIDER",
    desc: "圈内流传与多方信源交叉的料，统一标注可信度，哪些是传闻、哪些坐实，一目了然。",
    meta: "内幕线索 89 条",
    icon: "ri-vip-diamond-line",
  },
];

export const hotTopics = [
  { rank: 1, title: "头部主播带货数据集体注水疑云，平台为何集体沉默", tag: "深扒", heat: "热度 98.2 万", delta: "上升 12" },
  { rank: 2, title: "某千万粉博主一夜改名换头像，评论区开始考古旧号", tag: "人物起底", heat: "热度 86.7 万", delta: "上升 8" },
  { rank: 3, title: "学历注水再添一锤：公开简历与登记信息对不上", tag: "背景揭秘", heat: "热度 74.3 万", delta: "上升 21" },
  { rank: 4, title: "圈内传闻其团队已散伙，直播间的「家人」还在等", tag: "内幕", heat: "热度 65.1 万", delta: "新上榜" },
  { rank: 5, title: "早期「人淡如菊」人设被逐条翻出反向发言", tag: "深扒", heat: "热度 58.9 万", delta: "上升 3" },
  { rank: 6, title: "联动翻车之后，双方声明为何连标点都像同一套模板", tag: "内幕", heat: "热度 47.6 万", delta: "下降 2" },
  { rank: 7, title: "旧账号清空两年后再度被挖，一句旧梗引爆全网", tag: "人物起底", heat: "热度 39.2 万", delta: "上升 9" },
  { rank: 8, title: "被退订的自媒体怎么靠同一篇稿子反复起号", tag: "背景揭秘", heat: "热度 33.4 万", delta: "新上榜" },
];

export const persons = [
  {
    name: "雪梨北北",
    role: "情感区博主",
    label: "人设反复",
    tags: ["初期人设", "态度转变"],
    summary: "公开人设从「理性姐姐」转向「人间清醒」，旧稿与近稿口径多处对不上。",
    heat: "热度 42.1 万",
    img: "https://readdy.ai/api/search-image?query=Minimal%20editorial%20portrait%20of%20a%20silhouette%20figure%20viewed%20from%20behind%20with%20shoulder-length%20hair%2C%20soft%20vermilion%20red%20rim%20lighting%20tracing%20the%20outline%2C%20deep%20warm%20charcoal%20background%2C%20single%20thin%20gold%20archival%20frame%20corner%2C%20no%20visible%20face%2C%20stylized%20flat%20vector%20illustration%2C%20restrained%20clean%20composition%2C%20moody%20dramatic%20studio%20lighting%2C%20high%20contrast%20warm%20tones&width=640&height=640&seq=person-01&orientation=squarish",
  },
  {
    name: "老房说真话",
    role: "房产测评号",
    label: "合作摇摆",
    tags: ["恰饭史", "推荐反复"],
    summary: "两年内对同一楼盘评价三度反转，粉丝整理出其合作名单的时间线。",
    heat: "热度 38.6 万",
    img: "https://readdy.ai/api/search-image?query=Minimal%20editorial%20portrait%20of%20a%20solitary%20silhouette%20figure%20sitting%20at%20a%20desk%20seen%20from%20behind%2C%20warm%20vermilion%20rim%20light%20and%20amber%20desk%20lamp%20glow%2C%20deep%20charcoal%20warm%20background%20with%20faint%20graph%20lines%2C%20no%20visible%20face%2C%20stylized%20flat%20vector%20illustration%2C%20restrained%20clean%20cinematic%20composition%2C%20high%20contrast%20moody%20lighting&width=640&height=640&seq=person-02&orientation=squarish",
  },
  {
    name: "半岛电台",
    role: "城市播客",
    label: "改名重置",
    tags: ["频道迭代", "旧内容"],
    summary: "播客屡次改名清空，老听众质疑其「从头再来」背后的团队变动内幕。",
    heat: "热度 27.9 万",
    img: "https://readdy.ai/api/search-image?query=Minimal%20editorial%20portrait%20of%20a%20retro%20microphone%20silhouette%20in%20the%20foreground%20with%20a%20blurred%20human%20figure%20stepping%20away%20behind%20it%2C%20warm%20amber%20and%20vermilion%20gradient%20lighting%2C%20deep%20charcoal%20background%2C%20thin%20gold%20archival%20lines%2C%20no%20visible%20face%2C%20stylized%20flat%20vector%20illustration%2C%20restrained%20clean%20composition%2C%20cinematic%20moody%20light&width=640&height=640&seq=person-03&orientation=squarish",
  },
  {
    name: "陆离观察",
    role: "时评类账号",
    label: "观点回旋",
    tags: ["前后表态", "站队史"],
    summary: "对同一事件不同时期表态被整理成对照表，争议集中在其「适时变脸」。",
    heat: "热度 25.4 万",
    img: "https://readdy.ai/api/search-image?query=Minimal%20editorial%20portrait%20of%20a%20silhouette%20figure%20standing%20before%20a%20tall%20stack%20of%20paper%20documents%2C%20warm%20vermilion%20backlight%20casting%20long%20shadows%2C%20deep%20charcoal%20background%2C%20floating%20translucent%20paper%20sheets%2C%20no%20visible%20face%2C%20stylized%20flat%20vector%20illustration%2C%20restrained%20clean%20composition%2C%20dramatic%20high%20contrast%20warm%20lighting&width=640&height=640&seq=person-04&orientation=squarish",
  },
  {
    name: "三斤饭团",
    role: "美食探店",
    label: "恰饭密集",
    tags: ["探店软广", "评分异常"],
    summary: "探店好评率与投放记录高度重合，评论区大量「避雷」反馈被删。",
    heat: "热度 22.8 万",
    img: "https://readdy.ai/api/search-image?query=Minimal%20editorial%20portrait%20of%20a%20silhouette%20figure%20holding%20up%20a%20camera%20phone%20toward%20a%20dish%20on%20a%20table%2C%20warm%20amber%20food-booth%20glow%20with%20vermilion%20accents%2C%20deep%20charcoal%20background%2C%20no%20visible%20face%2C%20stylized%20flat%20vector%20illustration%2C%20restrained%20clean%20cinematic%20composition%2C%20moody%20dramatic%20lighting&width=640&height=640&seq=person-05&orientation=squarish",
  },
  {
    name: "Kiki茶话会",
    role: "闲聊主播",
    label: "身份存疑",
    tags: ["人设包装", "履历核对"],
    summary: "对外「海归高管」身份被逐项核验，多条履历查无实据，属待核实状态。",
    heat: "热度 19.3 万",
    img: "https://readdy.ai/api/search-image?query=Minimal%20editorial%20portrait%20of%20a%20silhouette%20figure%20holding%20a%20tea%20cup%20near%20lips%20while%20a%20second%20shadowy%20figure%20watches%20from%20a%20distance%2C%20warm%20vermilion%20and%20amber%20split%20lighting%2C%20deep%20charcoal%20background%20with%20subtle%20smoke%2C%20no%20visible%20face%2C%20stylized%20flat%20vector%20illustration%2C%20restrained%20clean%20moody%20composition&width=640&height=640&seq=person-06&orientation=squarish",
  },
];

export const features = [
  {
    cat: "深扒专题",
    tag: "人设 · 注水",
    title: "一个「清冷人设」是怎么被拆到只剩骨架的",
    summary: "我们从首条视频起逐月比对其公开口径，把塑造期、爆发期、塌房期三段的人设误差做成了一张可核验的对照表。",
    read: "阅读 12 分钟",
    date: "本周更新",
    img: "https://readdy.ai/api/search-image?query=Wide%20stylized%20editorial%20illustration%20of%20scattered%20paper%20documents%20connected%20by%20thin%20gold%20threads%20forming%20a%20web%20across%20a%20dark%20table%2C%20a%20single%20warm%20vermilion%20spotlight%20overhead%2C%20deep%20charcoal%20background%2C%20floating%20translucent%20document%20sheets%2C%20symbolizing%20research%20and%20fact%20checking%2C%20flat%20modern%20vector%20art%2C%20restrained%20clean%20cinematic%20composition%2C%20moody%20dramatic%20lighting&width=960&height=640&seq=feature-01&orientation=landscape",
  },
  {
    cat: "人物起底",
    tag: "考古 · 旧号",
    title: "千万粉账号改名重来，老内容去哪了",
    summary: "账号名、头像、简介乃至私域导流都在悄悄切换，我们回溯了改名前的完整动作时间线。",
    read: "阅读 9 分钟",
    date: "本周更新",
    img: "https://readdy.ai/api/search-image?query=Wide%20stylized%20editorial%20illustration%20of%20an%20old%20photo%20album%20and%20time-stamped%20cards%20fanned%20across%20a%20dark%20desk%20with%20warm%20amber%20accent%20light%2C%20a%20pair%20of%20hands%20about%20to%20flip%20one%20card%2C%20deep%20charcoal%20background%2C%20symbolizing%20archive%20digging%20and%20timeline%20research%2C%20flat%20vector%20art%2C%20restrained%20clean%20cinematic%20composition%2C%20warm%20moody%20lighting&width=960&height=640&seq=feature-02&orientation=landscape",
  },
  {
    cat: "背景揭秘",
    tag: "履历 · 核验",
    title: "「海归高管」简历逐条核验：三个查无实据",
    summary: "把对外简历里的学位、任职与奖项拆成条目，逐条对应可公开的登记信息，结果一目了然。",
    read: "阅读 11 分钟",
    date: "本周更新",
    img: "https://readdy.ai/api/search-image?query=Wide%20stylized%20editorial%20illustration%20of%20a%20magnifying%20glass%20hovering%20over%20a%20resume%20with%20rows%20of%20faded%20text%20and%20stamp%20marks%2C%20warm%20vermilion%20and%20amber%20dual%20tone%20lighting%2C%20deep%20charcoal%20background%2C%20thin%20gold%20frame%20corners%2C%20symbolizing%20background%20verification%2C%20flat%20vector%20art%2C%20restrained%20clean%20composition%2C%20dramatic%20cinematic%20warm%20light&width=960&height=640&seq=feature-03&orientation=landscape",
  },
  {
    cat: "内幕",
    tag: "团队 · 传闻",
    title: "直播间的「家人」，等不到那场散伙官宣",
    summary: "多方信源交叉出的团队变动线索，我们按可信度分三档标注，哪些是实锤、哪些仅是传闻。",
    read: "阅读 8 分钟",
    date: "本周更新",
    img: "https://readdy.ai/api/search-image?query=Wide%20stylized%20editorial%20illustration%20of%20several%20abstract%20human%20silhouettes%20in%20a%20line%20with%20one%20stepping%20out%20and%20walking%20away%20under%20a%20single%20warm%20vermilion%20spotlight%2C%20deep%20charcoal%20background%20with%20amber%20haze%2C%20symbolizing%20team%20breakup%20and%20rumor%2C%20flat%20vector%20art%2C%20restrained%20clean%20cinematic%20composition%2C%20moody%20dramatic%20warm%20light&width=960&height=640&seq=feature-04&orientation=landscape",
  },
];

export const timeline = [
  { date: "2023.04", title: "早期起号期", desc: "账号以素人身份切入，人设与如今高度一致，属于「最早版本」，后续多以此为基准比对。", tag: "起底基准", tone: "neutral" },
  { date: "2024.07", title: "首次转向", desc: "因一次合作露出旧料，首次出现口径调整；彼时粉丝已开始整理其前后表态。", tag: "反转点 1", tone: "warn" },
  { date: "2025.02", title: "数据质疑发酵", desc: "投放后台疑似流出截图，带货转化数据被大面积质疑，平台未公开回应。", tag: "质疑", tone: "warn" },
  { date: "2025.11", title: "改名清空", desc: "一夜之间改名、清空作品，评论区考古潮爆发，旧号数据被逐帧回溯。", tag: "重置", tone: "danger" },
  { date: "2026.03", title: "二次起号", desc: "换账号换赛道回归，人设重讲，但团队是否原班人马成新疑点。", tag: "再起", tone: "neutral" },
  { date: "2026.08", title: "多方内幕交叉", desc: "散伙、换团队等传闻聚集，本站在逐一核验可信度，未坐实部分仅作线索存档。", tag: "待核实", tone: "accent" },
];

export const topicWall = [
  { topic: "人设崩塌", count: 421 },
  { topic: "带货翻车", count: 368 },
  { topic: "学历注水", count: 253 },
  { topic: "言论考古", count: 306 },
  { topic: "数据注水", count: 187 },
  { topic: "恰饭翻车", count: 214 },
  { topic: "改名重置", count: 141 },
  { topic: "站队回旋", count: 96 },
  { topic: "账号买卖", count: 78 },
  { topic: "团队散伙", count: 129 },
  { topic: "旧号残留", count: 64 },
  { topic: "人设代运营", count: 57 },
  { topic: "截图存疑", count: 88 },
  { topic: "删评控评", count: 152 },
  { topic: "履历核验", count: 173 },
  { topic: "联动反噬", count: 105 },
];

export const collections = [
  { name: "人物起底全档案", en: "PERSON FILES", desc: "以人物为单位的完整起底合集", count: 3420, kind: "档案" },
  { name: "内幕线索库", en: "INSIDER LOG", desc: "多方信源与传闻的交叉存档", count: 891, kind: "线索" },
  { name: "带货翻车复盘", en: "LIVE-SALE", desc: "头部主播翻车案例的完整复盘", count: 156, kind: "专题" },
  { name: "言论考古时间线", en: "ARCHIVE", desc: "前后口径比对与表态回溯", count: 274, kind: "档案" },
  { name: "学历与履历核验", en: "RESUME", desc: "公开简历逐条比对专页", count: 98, kind: "核验" },
  { name: "改名重置记录", en: "REBRAND", desc: "账号迭代与内容重置追踪", count: 63, kind: "追踪" },
];